    // 食事内容を読み込む関数
    window.loadMealContent = function(facilityId, reservationDate, menuList = null) {
        // AJAXでメニューデータを取得
        const ajaxUrl = yutoriMypageVars.ajaxUrl;
        const nonce = yutoriMypageVars.getArcoBookingMenusNonce;
        
        fetch(ajaxUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'get_arco_booking_menus',
                nonce: nonce,
                facility_id: facilityId,
                reservation_date: reservationDate
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success && data.data) {
                generateMealTable(data.data, menuList);
            } else {
                const tbody = document.getElementById('popup_meal_content_tbody');
                if (tbody) {
                    tbody.innerHTML = '<tr><td colspan="4" class="text-center">メニューデータの読み込みに失敗しました</td></tr>';
                }
            }
        })
        .catch(error => {
            const tbody = document.getElementById('popup_meal_content_tbody');
            if (tbody) {
                tbody.innerHTML = '<tr><td colspan="4" class="text-center">メニューデータの読み込み中にエラーが発生しました</td></tr>';
            }
        });
    }
    
    // 食事テーブルを生成する関数
    window.generateMealTable = function(menuData, menuList) {
        const tbody = document.getElementById('popup_meal_content_tbody');
        if (!tbody) {
            return;
        }

        tbody.innerHTML = '';
        
        // 既存の注文内容を解析
        const existingOrders = {};
        if (menuList) {
            const menuItems = menuList.split('|');
            menuItems.forEach(item => {
                const parts = item.split('=');
                if (parts.length >= 4) {
                    const menuId = parts[0];
                    const quantity = parts[3];
                    existingOrders[menuId] = quantity;
                }
            });
        }
        
        // メニューデータからテーブルを生成
        if (!Array.isArray(menuData)) {
            tbody.innerHTML = '<tr><td colspan="4" class="text-center">メニューデータの形式が正しくありません</td></tr>';
            return;
        }
        
        if (menuData.length === 0) {
            tbody.innerHTML = '<tr><td colspan="4" class="text-center">メニュー情報がありません</td></tr>';
            return;
        }
        
        menuData.forEach(category => {
            if (category.items && Array.isArray(category.items)) {
                category.items.forEach(item => {
                    const row = document.createElement('tr');
                    const existingQuantity = existingOrders[item.id] || '';

                    row.innerHTML = `
                        <td>${category.category_name || 'その他'}</td>
                        <td>${item.name || '料理名不明'}</td>
                        <td class="price-cell">¥${(item.price || 0).toLocaleString()}</td>
                        <td>
                            <select name="menu_quantity[${item.id}]" class="form-control quantity-select" data-is-main="${item.is_main}" data-menu-id="${item.id}" data-price="${item.price || 0}">
                                <option value="">-</option>
                                ${Array.from({length: 105-1}, (_, i) => {
                                    const value = i + 2;
                                    return `<option value="${value}" ${existingQuantity == value ? 'selected' : ''}>${value}</option>`;
                                }).join('')}
                            </select>
                        </td>
                    `;
                    
                    tbody.appendChild(row);
                });
            }
        });
        
        // 数量変更イベントを追加
        const quantitySelects = tbody.querySelectorAll('.quantity-select');
        quantitySelects.forEach(select => {
            select.addEventListener('change', calculateTotalPrice);
        });
        
        // 合計金額を計算
        calculateTotalPrice();
    }
    
    // 合計金額を計算する関数（既存の関数を再利用）
    window.calculateTotalPrice = function() {
        // ポップアップ内の要素を検索
        const quantitySelects = document.querySelectorAll('#popup_reservationForm .quantity-select');
        let total = 0;
        quantitySelects.forEach(select => {
            const quantity = parseInt(select.value) || 0;
            const price = parseInt(select.dataset.price) || 0;
            total += quantity * price;
        });
        // ポップアップ内の要素を検索
        const totalPriceElement = document.getElementById('popup_totalPrice');
        if (totalPriceElement) {
            totalPriceElement.textContent = '¥' + total.toLocaleString();
        }
    }